export default "__VITE_ASSET__CwCVvWH1__"